import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import {
  Router,
  NavigationEnd,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
} from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { getMessaging, getToken} from 'firebase/messaging';
import { environment } from '../environments/environment';
import { AuthService } from 'src/app/_services/auth.service';
import { UserService } from './_services/user.service';
import { IUser } from './_interfaces/IUser.types';
import { setDoc } from 'firebase/firestore';
import {
  getFirestore,
  collection
} from 'firebase/firestore';
import { doc} from 'firebase/firestore';
import { getAuth, signInAnonymously } from "firebase/auth";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  title = 'vendor-panel';
  showSidebar: boolean = false;
  showNavbar: boolean = false;
  showFooter: boolean = false;
  isLoading: boolean = false;
  authClass: boolean = false;
  accessToken: string | null = null;
  deviceInfo = {
    browser: '',
    browser_version: '',
    device: '',
    deviceType: '',
    orientation: '',
    os: '',
    os_version: '',
    userAgent: '',
  };
  deviceId: string = '';
  fcmToken: string = '';
  user!: IUser;

  constructor(
    private _router: Router,
    private _deviceService: DeviceDetectorService,
    private _authService: AuthService,
    private _userService: UserService,
  ) {
    this._userService.userObservable.subscribe((user: IUser) => {
      this.user = user;
    });
    this.deviceInfo = this._deviceService.getDeviceInfo();
    this.requestPermission();

    this._authService.accessTokenObservable.subscribe((accessToken) => {
      this.accessToken = accessToken;
      if (accessToken) {
        this.showSidebar = true;
        this.showNavbar = true;
        this.showFooter = true;
        this.authClass = true;
        this.registerDevice();
      } else {
        this.showSidebar = false;
        this.showNavbar = false;
        this.showFooter = false;
        this.authClass = false;
      }
    });

    this._router.events.forEach((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
    });

    const auth = getAuth();
    signInAnonymously(auth).then(() => console.log("Success")).catch(e => console.log(e));

  }

  async ngOnInit() {
    // Profile pictures can 404 (deleted Firebase object, expired Google avatar URL).
    // `error` doesn't bubble, so listen in the capture phase and fall back once.
    document.addEventListener('error', (event: Event) => {
      const img = event.target as HTMLImageElement;
      if (img?.tagName === 'IMG' && img.matches('.tbleimg, .iq-top-navbar img.rounded, app-profile img.imagePreview, .bookingdetailcustomer .profileimage img') && !img.dataset['fallback']) {
        img.dataset['fallback'] = '1';
        img.src = 'assets/images_v2/dummyProfile.png';
      }
    }, true);

    if (this.user && this.user._id) {
      this.getChatUser('online');
    }
    document.addEventListener("visibilitychange", (event) => {
      if (document.visibilityState == "visible" && this.user && this.user._id) {
        this.getChatUser('online');
      }
    })

    window.onbeforeunload = () => {
      if (this.user && this.user._id) {
        this.getChatUser('offline');
      }
    }

    window.addEventListener('online', () => {
      if (this.user && this.user._id) {
        this.getChatUser('online');
      }
    });
    this.deviceId = `${this.deviceInfo.os_version}-${this.deviceInfo.deviceType}-${this.deviceInfo.browser}-${this.deviceInfo.browser_version}`;
    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      let top = document.getElementById('scrollToTop');
      if (top !== null) {
        top.scrollIntoView();
        top = null;
      }
      // Close the off-canvas sidebar after navigating on small screens
      if (window.innerWidth <= 1299) {
        this.closeSidebar();
      }
    });
  }

  // The sidebar is an off-canvas drawer up to 1299px. Its open state is the
  // `sidebar-main` class on <body>, toggled by `.wrapper-menu` in assets/js/custom.js.
  closeSidebar(): void {
    document.body.classList.remove('sidebar-main');
    document.querySelector('.wrapper-menu')?.classList.remove('open');
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeSidebar();
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 1299) {
      this.closeSidebar();
    }
  }

  requestPermission() {
    try {
      const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey }).then(
      (fcmToken) => {
        this.fcmToken = fcmToken;
        this._authService.deviceId = fcmToken;
        this.registerDevice();
      }
    );
    } catch (error) {
      console.log(error,"requestPermission")
    }
  }

  registerDevice() {
    if (this.accessToken && this.fcmToken) {
      this._authService
        .fcm({ deviceId: this.deviceId, fcm: this.fcmToken })
        .subscribe((response: any) => {
          this._authService.deviceId = this.deviceId;
        });
    }
  }



  async getChatUser(item: string) {
    const db = getFirestore();
    const citiesRef = collection(db, 'users');
    setDoc(
      doc(citiesRef, this.user._id),
      {
        status: item,
      },
      { merge: true }
    );
  }

}
